import { createSelector } from 'reselect';

import type { RootState } from 'Store/rootReducer';

const emptyTripInformation = {
  adults: [],
  kids: [],
} as RootState['tripInformation'];

export const tripInformationSelector = (state: AppState): RootState['tripInformation'] =>
  state.tripInformation ?? emptyTripInformation;

const tripCriteriaSelector = (state: AppState) => state.tripCriteria ?? {};

const getAdults = createSelector(tripInformationSelector, ({ adults }) => adults || []);
const getAdultsNumber: (state: AppState) => number = createSelector(
  tripInformationSelector,
  ({ adults }) => (adults || []).length,
);
const getKids = createSelector(tripInformationSelector, ({ kids }) => kids || []);
const getMainContactOptins = createSelector(
  tripCriteriaSelector,
  (tripCriteria: { mainContact?: unknown }) => tripCriteria.mainContact,
);
export { getAdults, getAdultsNumber, getKids, getMainContactOptins };
